module.exports = __webpack_public_path__ + "img/city2.61dff35a.png";